module.exports = __webpack_public_path__ + "img/bed.8043881a.png";